import React, { useState, useEffect } from "react";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { useNavigate } from "react-router-dom"; 
import Swal from "sweetalert2";
// import Select from "react-select";
import Select, { components } from "react-select";



const indianStates = [
  { value: "ALL", label: "All India" },
  { value: "AP", label: "Andhra Pradesh" },
  { value: "AR", label: "Arunachal Pradesh" },
  { value: "AS", label: "Assam" },
  { value: "BR", label: "Bihar" },
  { value: "CT", label: "Chhattisgarh" },
  { value: "GA", label: "Goa" },
  { value: "GJ", label: "Gujarat" },
  { value: "HR", label: "Haryana" },
  { value: "HP", label: "Himachal Pradesh" },
  { value: "JH", label: "Jharkhand" },
  { value: "KA", label: "Karnataka" },
  { value: "KL", label: "Kerala" },
  { value: "MP", label: "Madhya Pradesh" },
  { value: "MH", label: "Maharashtra" },
  { value: "MN", label: "Manipur" },
  { value: "ML", label: "Meghalaya" },
  { value: "MZ", label: "Mizoram" },
  { value: "NL", label: "Nagaland" },
  { value: "OR", label: "Odisha" },
  { value: "PB", label: "Punjab" },
  { value: "RJ", label: "Rajasthan" },
  { value: "SK", label: "Sikkim" },
  { value: "TN", label: "Tamil Nadu" },
  { value: "TS", label: "Telangana" },
  { value: "TR", label: "Tripura" },
  { value: "UP", label: "Uttar Pradesh" },
  { value: "UK", label: "Uttarakhand" },
  { value: "WB", label: "West Bengal" },
  { value: "AN", label: "Andaman and Nicobar Islands" },
  { value: "CH", label: "Chandigarh" },
  { value: "DN", label: "Dadra and Nagar Haveli and Daman and Diu" },
  { value: "DL", label: "Delhi" },
  { value: "JK", label: "Jammu and Kashmir" },
  { value: "LA", label: "Ladakh" },
  { value: "LD", label: "Lakshadweep" },
  { value: "PY", label: "Puducherry" },
];


const CustomOption = (props) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ marginRight: 8 }}
      />
      {props.label}
    </components.Option>
  );
};


const ServiceTeamAdd = () => {
  const seller_id = localStorage.getItem("seller_id");
const [categories, setCategories] = useState([]);
const navigate = useNavigate();
const [formData, setFormData] = useState({
  name: "",
  phone: "",
  email: "",
  experience: "",
  pan_card: "",
  aadhar_card: "",
  category_id: "",
  about: "",
  phone_whatsapp: "",
   phone_alternate: "", 
});

const [resume, setResume] = useState(null);
const [profileImage, setProfileImage] = useState(null);

  const [resumeFiles, setResumeFiles] = useState([]);
  const [profileImages, setProfileImages] = useState([]);



const [selectedLevel1, setSelectedLevel1] = useState("");
const [selectedLevel2, setSelectedLevel2] = useState([]);
const [selectedLevel3, setSelectedLevel3] = useState([]);
const [selectedLevel4, setSelectedLevel4] = useState([]);
const [selectedLevel5, setSelectedLevel5] = useState("");

const [level2Options, setLevel2Options] = useState([]);
const [level3Options, setLevel3Options] = useState([]);
const [level4Options, setLevel4Options] = useState([]);
const [level5Options, setLevel5Options] = useState([]);


 const [selectedStates, setSelectedStates] = useState([]);
 


useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${baseurl}/getAllServiceCategories`);
      const categories = res.data.data || [];

      // Sort alphabetically (ascending)
      categories.sort((a, b) => a.service_title.localeCompare(b.service_title));

      setCategories(categories);
    } catch (err) {
      console.error("Error fetching categories", err);
    }
  };
  fetchCategories();
}, []);


const handleChange = (e) => {
  const { name, value } = e.target;

  // Only apply restriction to phone fields
  if (name === 'phone' || name === 'phone_alternate' || name === 'phone_whatsapp') {
    // Remove non-digit characters
    let sanitizedValue = value.replace(/\D/g, '');

    // Limit to 10 digits
    if (sanitizedValue.length > 10) {
      sanitizedValue = sanitizedValue.slice(0, 10);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: sanitizedValue,
    }));
  } else {
    // For other fields, update normally
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};


// const handleFileChange = (e, type) => {
//   if (type === "resume") setResume(e.target.files[0]);
//   else if (type === "profileImage") setProfileImage(e.target.files[0]);
// };


 const handleFileChange = (e, type) => {
    const files = Array.from(e.target.files);
    if (type === "resume") setResumeFiles(files);
    if (type === "profileImage") setProfileImages(files);
  };

const handleLevelChange = (e, level) => {
  if (level === 1) {
    const val = e.target.value;
    setSelectedLevel1(val);
    const level2 = categories.filter((cat) => cat.parent_id == val);
    setLevel2Options(level2);
    setSelectedLevel2([]);
    setSelectedLevel3([]);
    setSelectedLevel4([]);
    setLevel3Options([]);
    setLevel4Options([]);
    setSelectedStates([]);
    setFormData((prev) => ({ ...prev, category_id: val }));
  }

  if (level === 2) {
    setSelectedLevel2(e);
    const selectedIds = e.map((item) => item.value);
    const level3 = categories.filter((cat) => selectedIds.includes(cat.parent_id));
    setLevel3Options(level3);
    setSelectedLevel3([]);
    setSelectedLevel4([]);
    setLevel4Options([]);
    setSelectedStates([]);
    setFormData((prev) => ({ ...prev, category_ids: selectedIds.join(",") }));
  }

  if (level === 3) {
    setSelectedLevel3(e);
    const selectedIds = e.map((item) => item.value);
    const level4 = categories.filter((cat) => selectedIds.includes(cat.parent_id));
    setLevel4Options(level4);
    setSelectedLevel4([]);
    setSelectedStates([]);
    setFormData((prev) => ({ ...prev, sub_category_ids: selectedIds.join(",") }));
  }

  if (level === 4) {
    setSelectedLevel4(e);
    const selectedIds = e.map((item) => item.value);
    setFormData((prev) => ({ ...prev, sub_sub_category_ids: selectedIds.join(",") }));
  }
};
















const handleSubmit = async (e) => {
  e.preventDefault();

  // Combine selected categories from multiple levels
  const allCategoryIds = [
    selectedLevel1,
    ...selectedLevel2.map(item => item.value),
    ...selectedLevel3.map(item => item.value),
    ...selectedLevel4.map(item => item.value),
  ].filter(Boolean); // Remove undefined or empty

  // Combine selected states into a JSON array
  const selectedStateIds = selectedStates.map(item => item.value);

  // Prepare form data
  const data = new FormData();
  Object.entries(formData).forEach(([key, value]) => data.append(key, value));

  data.append("seller_id", seller_id);
  data.append("category_new", allCategoryIds.join(","));
  

    // ✅ Append multiple resume files
  if (resumeFiles && resumeFiles.length > 0) {
    resumeFiles.forEach((file) => data.append("resume", file));
  }

  // ✅ Append multiple profile images
  if (profileImages && profileImages.length > 0) {
    profileImages.forEach((file) => data.append("profile_image", file));
  }


  // ✅ Send as proper JSON array
  data.append("selected_states", JSON.stringify(selectedStateIds));

  if (resume) data.append("resume", resume);
  if (profileImage) data.append("profile_image", profileImage);

  // Debug
  console.log("Submitting form data:");
  for (let pair of data.entries()) {
    console.log(`${pair[0]}:`, pair[1]);
  }

  try {
    const res = await axios.post(`${baseurl}addServiceMan`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    await Swal.fire({
      icon: "success",
      title: "Success!",
      text: "Service man profile added successfully!",
      timer: 2000,
      showConfirmButton: false,
    });
    
    navigate(-1);

    // ❌ No reset or navigation per your note

  } catch (err) {
    console.error("Error submitting form", err);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to add profile.",
    });
  }
};










  return (
    <>
      <SellerNavbar />
      <div className="container-fluid">
        <div className="row my-3 g-2">
          <div className="col-md-2">
            <SellerSidebar />
          </div>
          <div className="col-md-10 text-start">
            <div className="card p-4">
              <h4 className="mb-4">Add Service Man Profile</h4>
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="row g-3">
                  <div className="col-md-12">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Name"
                      required
                    />
                  </div>


                  <div className="col-md-12">
  <textarea
    name="about"
    value={formData.about}
    onChange={handleChange}
    className="form-control"
    placeholder="Write About Yourself"
    rows={4}   // You can adjust rows as needed
    required
  />
</div>


                  


                  <div className="col-md-6">
  <input
    type="text"
    name="phone"
    value={formData.phone}
    onChange={handleChange}
    className="form-control"
    placeholder="Phone Number"
    required
  />
</div>

<div className="col-md-6">
  <input
    type="text"
    name="phone_alternate"
    value={formData.phone_alternate}
    onChange={handleChange}
    className="form-control"
    placeholder="Alternate Phone Number"
    required
  />
</div>

<div className="col-md-6">
  <input
    type="text"
    name="phone_whatsapp"
    value={formData.phone_whatsapp}
    onChange={handleChange}
    className="form-control"
    placeholder="Whatsapp Number"
    required
  />
</div>

                  
                  <div className="col-md-6">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Email"
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="text"
                      name="experience"
                      value={formData.experience}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Experience (e.g. 2 years)"
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="text"
                      name="pan_card"
                      value={formData.pan_card}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="PAN Card Number"
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="text"
                      name="aadhar_card"
                      value={formData.aadhar_card}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Aadhar Card Number"
                    />
                  </div>



 

{/* Level 1 - What We Do */}
<div className="col-md-4">
  <label className="form-label">What We Do</label>
  <select
    className="form-select"
    value={selectedLevel1}
    onChange={(e) => handleLevelChange(e, 1)}
  >
    <option value="">Select What We Do</option>
    {categories
      .filter((cat) => !cat.parent_id)
      .map((cat) => (
        <option key={cat.id} value={cat.id}>
          {cat.service_title}
        </option>
      ))}
  </select>
</div>

{/* Level 2 - Category */}
{level2Options.length > 0 && (
  <div className="col-md-4">
    <label className="form-label">Category</label>
    <Select
      isMulti
      closeMenuOnSelect={false}
      options={level2Options.map((cat) => ({
        value: cat.id,
        label: cat.service_title,
      }))}
      value={selectedLevel2}
      onChange={(e) => handleLevelChange(e, 2)}
      components={{ Option: CustomOption }}
    />
  </div>
)}

{/* Level 3 - Subcategory */}
{level3Options.length > 0 && (
  <div className="col-md-4">
    <label className="form-label">Sub Category</label>
    <Select
      isMulti
      closeMenuOnSelect={false}
      options={level3Options.map((cat) => ({
        value: cat.id,
        label: cat.service_title,
      }))}
      value={selectedLevel3}
      onChange={(e) => handleLevelChange(e, 3)}
      components={{ Option: CustomOption }}
    />
  </div>
)}

{/* Level 4 - Sub Sub Sub Category */}
{level4Options.length > 0 && (
  <div className="col-md-4">
    <label className="form-label">Sub Sub Sub Category</label>
    <Select
      isMulti
      closeMenuOnSelect={false}
      options={level4Options.map((cat) => ({
        value: cat.id,
        label: cat.service_title,
      }))}
      value={selectedLevel4}
      onChange={(e) => handleLevelChange(e, 4)}
      components={{ Option: CustomOption }}
    />
  </div>
)}

{/* States - Only show if Level 4 is selected */}
{selectedLevel4.length > 0 && (
  <div className="col-md-4">
    <label className="form-label">Select State(s)</label>
    <Select
      isMulti
      closeMenuOnSelect={false}
      options={indianStates}
      value={selectedStates}
      onChange={(e) => setSelectedStates(e)}
      components={{ Option: CustomOption }}
    />
  </div>
)}











                 <div>
        <label>Upload Resume(s)</label>
        <input type="file" multiple accept=".pdf" onChange={(e) => handleFileChange(e, "resume")} />
        <ul>
          {resumeFiles.map((file, i) => (
            <li key={i}>{file.name}</li>
          ))}
        </ul>
      </div>

      <div>
        <label>Upload Profile Image(s)</label>
        <input type="file" multiple accept="image/*" onChange={(e) => handleFileChange(e, "profileImage")} />
        <div style={{ display: "flex", gap: "10px", marginTop: "5px" }}>
          {profileImages.map((file, i) => (
            <img
              key={i}
              src={URL.createObjectURL(file)}
              alt="preview"
              width={60}
              height={60}
              style={{ objectFit: "cover", borderRadius: "5px" }}
            />
          ))}
        </div>
      </div>


                  <div className="col-12 mt-3">
                    <button type="submit" className="btn btn-primary w-100">
                      Submit Profile
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceTeamAdd;
